import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticker',
  templateUrl: './ticker.component.html',
})
export class TickerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
